import type { QueryClient } from '@tanstack/react-query'

import { ga4Keys, trafficKeys } from '@/features/ga4-shared/keys'

import { integrationKeys } from '../queryKeys'

/**
 * What a GA4 connect, disconnect or import changes: the integration's health,
 * the Integrations list's badge, and the Traffic page's numbers. One list, so a
 * new dependent view is added here once.
 */
export function invalidateGa4(queryClient: QueryClient): Promise<unknown> {
  return Promise.all(
    [ga4Keys.all, integrationKeys.summaryAll, trafficKeys.all].map((queryKey) =>
      queryClient.invalidateQueries({ queryKey }),
    ),
  )
}
